<template>
    <app-layout title="Paket Pengadaan">
        <template #header>
            <BreadCrumb :breadcrumb="$page.props.bc" />
        </template>
        <div class="py-4">
            <div class="max-w-7xl mx-auto sm:px-6 lg:px-8">
                <div class="bg-white overflow-hidden shadow-xl sm:rounded-lg">
                    <section class="text-gray-600 body-font">
                        <div class="container px-5 py-5 mx-auto">
                            <div class="flex flex-wrap w-full mb-5 flex-col">
                                <Accordion :multiple="true" :activeIndex="[0, 1, 2, 3, 4]">
                                    <AccordionTab>
                                        <template #header>
                                            <span class="flex align-items-center gap-2 w-full">
                                                <span class="font-bold white-space-nowrap">Paket Pengadaan</span>
                                            </span>
                                        </template>
                                        <div class="p-4 lg:w-1/1 md:w-full">
                                            <div class="flex items-center gap-2">
                                                <JetLabel class="w-1/4 my-2" for="nama_paket_pengadaan" value="Nama Paket Pengadaan" />
                                                <InputText class="w-3/4" id="nama_paket_pengadaan" type="text" :class="{'p-invalid' : errors.nama_paket_pengadaan}" v-model="form.nama_paket_pengadaan" />
                                                <small v-if="errors.nama_paket_pengadaan" id="name-help" class="p-error">Nama Paket Pengadaan Wajib Diisi</small>
                                            </div>
                                        </div>
                                        <div class="p-4 lg:w-1/1 md:w-full">
                                            <div class="flex items-center gap-2">
                                                <JetLabel class="w-1/4 my-2" for="pagu_anggaran" value="Pagu Anggaran" />
                                                <InputNumber class="w-3/4" id="pagu_anggaran" type="text" :class="{'p-invalid' : errors.pagu_anggaran}" v-model="form.pagu_anggaran" />
                                                <small v-if="errors.pagu_anggaran" id="name-help" class="p-error">Pagu Anggaran Wajib Diisi</small>
                                            </div>
                                        </div>
                                        <div class="p-4 lg:w-1/1 md:w-full">
                                            <div class="flex items-center gap-2">
                                                <JetLabel class="w-1/4 my-2" for="jenis_pengadaan" value="Jenis Pengadaan" />
                                                <Dropdown class="w-3/4 md:w-14rem" v-model="form.jenis_pengadaan" :options="daftar_jenis_pengadaan" optionLabel="nama_pekerjaan" placeholder="Pilih Jenis Pengadaan" required="required" >
                                                    <template #option="slotProps">
                                                        <div class="country-item">
                                                            <div>{{slotProps.option.nama_pekerjaan}}</div>
                                                        </div>
                                                    </template>
                                                </Dropdown>
                                                <small v-if="errors.jenis_pengadaan" id="name-help" class="p-error">Jenis Pengadaan Wajib Diisi</small>
                                            </div>
                                        </div>
                                        <div class="p-4 lg:w-1/1 md:w-full">
                                            <div class="flex items-center gap-2">
                                                <JetLabel class="w-1/4 my-2" for="ruang_lingkup_pengadaan" value="Ruang Lingkup Pengadaan" />
                                                <InputText class="w-3/4" id="ruang_lingkup_pengadaan" type="text" :class="{'p-invalid' : errors.ruang_lingkup_pengadaan}" v-model="form.ruang_lingkup_pengadaan" />
                                                <small v-if="errors.ruang_lingkup_pengadaan" id="name-help" class="p-error">Ruang Lingkup Pengadaan Wajib Diisi</small>
                                            </div>
                                        </div>
                                        <div class="p-4 lg:w-1/1 md:w-full">
                                            <div class="flex items-center gap-2">
                                                <JetLabel class="w-1/4 my-2" for="spesifikasi_pekerjaan" value="Spesifikasi Pekerjaan" />
                                                <InputText class="w-3/4" id="spesifikasi_pekerjaan" type="text" :class="{'p-invalid' : errors.spesifikasi_pekerjaan}" v-model="form.spesifikasi_pekerjaan" />
                                                <small v-if="errors.spesifikasi_pekerjaan" id="name-help" class="p-error">Spesifikasi Pekerjaan Wajib Diisi</small>
                                            </div>
                                        </div>
                                        <div class="p-4 lg:w-1/1 md:w-full">
                                            <div class="flex items-center gap-2">
                                                <JetLabel class="w-1/4 my-2" for="mak" value="Mata Akun Kegiatan" />
                                                <InputText class="w-3/4" id="mak" type="text" :class="{'p-invalid' : errors.mak}" v-model="form.mak" />
                                                <small v-if="errors.mak" id="name-help" class="p-error">Mata Akun Kegiatan Wajib Diisi</small>
                                            </div>
                                        </div>
                                        <div class="p-4 lg:w-1/1 md:w-full">
                                            <div class="flex items-center gap-2">
                                                <JetLabel class="w-1/4 my-2" for="metode_pemilihan" value="Metode Pemilihan" />
                                                <Dropdown  class="w-3/4 md:w-14rem" v-model="form.metode_pemilihan" :options="daftar_metode_pemilihan" optionLabel="nama_metode_pemilihan" placeholder="Pilih Metode Pemilihan" required="required" >
                                                    <template #option="slotProps">
                                                        <div class="country-item">
                                                            <div>{{slotProps.option.nama_metode_pemilihan}}</div>
                                                        </div>
                                                    </template>
                                                </Dropdown>
                                                <small v-if="errors.metode_pemilihan" id="name-help" class="p-error">Metode Pemilihan Wajib Diisi</small>
                                            </div>
                                        </div>
                                        <div class="p-4 lg:w-1/1 md:w-full">
                                            <div class="flex items-center gap-2">
                                                <JetLabel class="w-1/4 my-2" for="ppk_id" value="Pejabat Pembuat Komitmen" /> 
                                                <Dropdown
                                                    class="w-3/4"
                                                    v-model="form.ppk_id"
                                                    :options="daftar_ppk"
                                                    optionLabel="fullname"
                                                    filter
                                                    filterBy="fullname"
                                                    @filter="fetchPPK"
                                                    placeholder="Select PPK"
                                                />
                                                <small v-if="errors.ppk_id" id="name-help" class="p-error">PPK Wajib Diisi</small>
                                            </div>
                                        </div>
                                    </AccordionTab>
                                    <AccordionTab>
                                        <template #header>
                                            <span class="flex align-items-center gap-2 w-full">
                                                <span class="font-bold white-space-nowrap">Jadwal</span>
                                            </span>
                                        </template>
                                        <div class="p-4 lg:w-1/1 md:w-full">
                                            <div class="flex items-center gap-2">
                                                <JetLabel class="w-1/4 my-2" for="jadwal_mulai_pemilihan_penyedia" value="Pemilihan Penyedia Mulai" />
                                                <Calendar class="w-3/4" id="jadwal_mulai_pemilihan_penyedia" type="date" :class="{'p-invalid' : errors.jadwal_mulai_pemilihan_penyedia}" v-model="form.jadwal_mulai_pemilihan_penyedia" dateFormat="dd/mm/yy" />
                                                <small v-if="errors.jadwal_mulai_pemilihan_penyedia" id="name-help" class="p-error">Jadwal Mulai Pemilihan Penyedia Wajib Diisi</small>    
                                            </div>
                                            <div class="flex items-center gap-2">
                                                <JetLabel class="w-1/4" for="jadwal_selesai_pemilihan_penyedia" value="Pemilihan Penyedia Selesai" />
                                                <Calendar class="w-3/4" id="jadwal_selesai_pemilihan_penyedia" type="date" :class="{'p-invalid' : errors.jadwal_selesai_pemilihan_penyedia}" v-model="form.jadwal_selesai_pemilihan_penyedia" dateFormat="dd/mm/yy" />
                                                <small v-if="errors.jadwal_selesai_pemilihan_penyedia" id="name-help" class="p-error">Jadwal Selesai Pemilihan Penyedia Wajib Diisi</small>
                                            </div>
                                        </div>
                                        <div class="p-4 lg:w-1/1 md:w-full">
                                            <div class="flex items-center gap-2">
                                                <JetLabel class="w-1/4 my-2" for="jadwal_mulai_pelaksanaan_kontrak" value="Pelaksanaan Kontrak Mulai" />
                                                <Calendar class="w-3/4" id="jadwal_mulai_pelaksanaan_kontrak" type="date" :class="{'p-invalid' : errors.jadwal_mulai_pelaksanaan_kontrak}" v-model="form.jadwal_mulai_pelaksanaan_kontrak" dateFormat="dd/mm/yy" />
                                                <small v-if="errors.jadwal_mulai_pelaksanaan_kontrak" id="name-help" class="p-error">Jadwal Mulai Pelaksanaan Kontrak Wajib Diisi</small>
                                            </div>
                                            <div class="flex items-center gap-2">
                                                 <JetLabel class="w-1/4" for="jadwal_selesai_pelaksanaan_kontrak" value="Pelaksanaan Kontrak Selesai" />
                                                <Calendar class="w-3/4" id="jadwal_selesai_pelaksanaan_kontrak" type="date" :class="{'p-invalid' : errors.jadwal_selesai_pelaksanaan_kontrak}" v-model="form.jadwal_selesai_pelaksanaan_kontrak" dateFormat="dd/mm/yy" />
                                                <small v-if="errors.jadwal_selesai_pelaksanaan_kontrak" id="name-help" class="p-error">Jadwal Selesai Pelaksanaan Kontrak Wajib Diisi</small>
                                            </div>
                                        </div>
                                    </AccordionTab>
                                </Accordion>
                            </div>
                            <div class="flex justify-end mt-5">
                                <button @click="submitForm" class="px-4 py-2 bg-blue-500 text-white rounded">
                                    Submit
                                </button>
                            </div>
                        </div>
                    </section>
                </div>
            </div>
        </div>
    </app-layout>
</template>


<script>
import axios from 'axios'

import { defineComponent } from "vue";
import AppLayout from "@/Layouts/AppLayout";
import BreadCrumb from "@/Components/BreadCrumb";
import JetLabel from "@/Jetstream/Label";
import { Inertia } from '@inertiajs/inertia'
import { useForm } from "@inertiajs/inertia-vue3"
import AppMenuBar from "@/Components/AppMenuBar.vue";
import DeleteDialog from "@/Components/DeleteDialog";
import DropdownWilayah from "@/Components/DropdownWilayah.vue";
import MapInput from "@/Components/MapInput.vue";
import { FilterMatchMode } from "primevue/api";
import Accordion from 'primevue/accordion';
import AccordionTab from 'primevue/accordiontab';
import AutoComplete from 'primevue/autocomplete';
import Button from "primevue/button";
import Calendar from 'primevue/calendar';
import Card from "primevue/card";
import Column from "primevue/column";
import DataTable from "primevue/datatable";
import Dialog from 'primevue/dialog';
import Divider from "primevue/divider";
import Dropdown from 'primevue/dropdown';
import FileUpload from 'primevue/fileupload';
import InputText from "primevue/inputtext";
import InputNumber from "primevue/inputnumber";
import Menubar from "primevue/menubar";
import MultiSelect from 'primevue/multiselect';
import OverlayPanel from 'primevue/overlaypanel';
import Password from "primevue/password";
import ProgressBar from 'primevue/progressbar';
import RadioButton from 'primevue/radiobutton';
import Textarea from 'primevue/textarea';
import pdfvuer from 'pdfvuer'

export default {
    name: "Index",
    layout: AppLayout,
    components: {
        AppMenuBar,
        JetLabel,
        DeleteDialog,
        DropdownWilayah,
        MapInput,
        Accordion,
        AccordionTab,
        AutoComplete,
        Button,
        Calendar,
        Card,
        Column,
        DataTable,
        Dialog,
        Divider,
        Dropdown,
        FileUpload,
        InputText,
        InputNumber,
        Menubar,
        MultiSelect,
        OverlayPanel,
        Password,
        ProgressBar,
        RadioButton,
        Textarea,
        pdf: pdfvuer,
    },
    props : {
        errors : Array,
        daftar_jenis_pengadaan : Array,
        daftar_metode_pemilihan : Array,
        daftar_ppk : Array,
    },
    data : function(){
        return {
            form : {
                name : '',
                permissions : [],
                menus : [],
            },
            ppkOptions: [],
        }
    },
    mounted() {
        this.fetchPPK({ value: "" });
    },
    methods : {
        async fetchPPK(event) {
            console.log("Keyword : ", event.value);
            try {
                const response = await axios.post(
                    "/paket_pengadaan/search_ppk",
                    {
                        params: {
                            keyword: event.value || "",
                        },
                    }
                );
                if (response.data && Array.isArray(response.data)) {
                    this.ppkOptions = response.data;
                }
            } catch (error) {
                console.error("Error fetching ppk:", error);
            }
        },
        submitForm(){
            // alert(this.form)
            Inertia.post('/paket_pengadaan/', this.form);
        }
    }
}
</script>
